import React, {Component} from 'react';
import {Circle, GoogleMap, Marker, Polygon, Polyline, Rectangle, withGoogleMap} from "react-google-maps";
import PropTypes from 'prop-types';
import {Method, SelectMode} from './Constants';
import _ from 'lodash';
import AppVariables from '../../common/AppVariables';

const LoadMap = withGoogleMap((props) => (<GoogleMap ref={props.onMapLoaded} {...props}/>));

export class MapView extends Component {

    static propTypes = {
        defaultZoom: PropTypes.number,
        onMapLoaded: PropTypes.func,
        zoom: PropTypes.number,
        onZoomChanged: PropTypes.func,
        defaultCenter: PropTypes.object,
        options: PropTypes.object,
        computationShapes: PropTypes.array,
        mapHeight: PropTypes.number,
        onRectBoundsChanged: PropTypes.func,
        onCircleRadiusChanged: PropTypes.func,

        //  
        onCenterChanged: PropTypes.func,
        onPathDefinitionComplete: PropTypes.func,
        userPath: PropTypes.array,
        completePathDefinition: PropTypes.bool,
        onPathUpdated: PropTypes.func,

        //  History data
        historyPath: PropTypes.any,
    };

    static defaultProps = {
        zoom: 7,
        defaultZoom: 7,
        defaultCenter: AppVariables.DefaultMapCoordinates,
        mapHeight: 480,
        options: {
            fullscreenControl: false,
            gestureHandling: 'greedy',
            disableDoubleClickZoom: false
        }
    };

    constructor(props){
        super(props);

        this.state = {
            mode: "",
            centerPoint: null,
            args: null,
        };

    }


    toggleMode(mode, args){

        this.setState({
            mode,
            args
        });

    }

    fitView(coords){

        if(coords.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            coords.forEach(t => bounds.extend(new window.google.maps.LatLng(t.lat, t.lng)));
            this._map.fitBounds(bounds);
        }

    }

    getCenter(){
        return this._map.getCenter();
    }

    render(){

        const props = this.props;
        const { mode , args , centerPoint  } = this.state;

        const renderHistoryPath = () => {

            const { historyPath }  = this.props;
            if(Array.isArray(historyPath) && historyPath.length > 0){

                return <Polyline path={historyPath}
                                 options={{
                                     clickable: false,
                                     strokeColor: '#0074d0',
                                     geodesic: true,
                                     strokeOpacity: 1,
                                     strokeWeight: 5,
                                     zIndex: -1
                                 }}/>

            }

            return null;
        };

        const renderDrawing = () => {

            const google = window.google;

            if(mode === Method.Manual){

                switch (args.type) {

                    case SelectMode.Circle:{

                        return args.radius ? <Circle radius={args.radius}
                                                     ref={r => this._areaCircle = r}
                                                     center={centerPoint}
                                                     editable
                                                     onRadiusChanged={() => {

                                                         const radius = this._areaCircle.getRadius();
                                                         if(this.props.onCircleRadiusChanged) {
                                                             this.props.onCircleRadiusChanged(radius);
                                                         }

                                                     }}
                                                     options={{ strokeColor: '#FF0000',
                                                                strokeOpacity: 0.8,
                                                                strokeWeight: 2,
                                                                fillColor: '#FF0000',
                                                                fillOpacity: 0.35,
                                                            }}/> : null;

                    }
                    case SelectMode.Rectangle:{

                        return args.bounds ? <Rectangle bounds={args.bounds}
                                                        editable
                                                        ref={r => this._areaRect = r}
                                                        onBoundsChanged={() => {

                                                            const bounds = this._areaRect.getBounds();
                                                            if(this.props.onRectBoundsChanged) {
                                                                this.props.onRectBoundsChanged(bounds);
                                                            }

                                                        }}
                                                        options={{  strokeColor: '#FF0000',
                                                                    strokeOpacity: 0.8,
                                                                    strokeWeight: 2,
                                                                    fillColor: '#FF0000',
                                                                    fillOpacity: 0.35
                                                                }}/> : null;

                    }
                    case SelectMode.UserDefined:{

                        let _shape;
                        if(this.props.completePathDefinition){

                            _shape = <Polygon key={"path"} path={this.props.userPath}
                                               options={{
                                                   strokeColor: '#ffe438',
                                                   geodesic: true,
                                                   strokeOpacity: 1,
                                                   fillColor: '#FF0000',
                                                   fillOpacity: 0.35
                                               }}/>;

                        }
                        else{
                            _shape = <Polyline key={"path"}
                                               path={this.props.userPath}
                                               options={{ strokeColor: '#ffe438', geodesic: true, strokeOpacity: 1 }}/>;
                        }

                        return [_shape].concat((this.props.userPath.map((x,i) => {
                            return <Marker key={i}
                                           position={x}
                                           onClick={evt => {

                                               if(i === 0){

                                                   if(this.props.onPathDefinitionComplete){

                                                       const lat = evt.latLng.lat();
                                                       const lng = evt.latLng.lng();
                                                       this.props.onPathDefinitionComplete(this.props.userPath.concat({ lat , lng }));

                                                   }

                                               }

                                           }}
                                           options={{

                                               icon: {
                                                   url: '/img/marker_dot.png',
                                                   scaledSize: {
                                                       width: 16,
                                                       height: 18
                                                   },
                                                   size: { width: 16, height: 18 },
                                                   anchorPoint: new window.google.maps.Point(8, 10),
                                                   anchor: new window.google.maps.Point(8, 10),
                                                   origin: new window.google.maps.Point(0, 0)
                                               }

                                           }}/>;

                        })));

                    }
                }

            }


            return null;
        };

        const renderComputationPaths = () => {

            if(Array.isArray(this.props.computationShapes)){

                return this.props.computationShapes.map((p,i) => {

                    if(_.isFunction(p.condition) && !p.condition(this)){
                        return null;
                    }

                    switch (p.type) {
                        case "line":
                            return <Polyline key={i} path={p.points} options={p.options}/>
                        case "rectangle":
                            return <Rectangle key={i} bounds={p.bounds} options={p.options}/>
                    }

                });

            }

            return null;
        };

        let mapOptions = _.clone(props.options);
        if(mode === Method.Manual && args.type === SelectMode.UserDefined && this.props.completePathDefinition){
            mapOptions.draggableCursor = 'default';
        }

        return <LoadMap onMapLoaded={r => {

                            this._map = r;

                            if(this.props.onMapLoaded){
                                this.props.onMapLoaded(r);
                            }

                        }}
                        containerElement={
                            <div style={{ width: '100%' , height: this.props.mapHeight, position: "relative" }} />
                        }
                        mapElement={
                            <div style={{ width: "100%", height: this.props.mapHeight }} />
                        }
                        onCenterChanged={() => {

                            const center = this.getCenter();
                            this.setState({
                                centerPoint: center
                            }, () => {

                                if(this.props.onCenterChanged){
                                    this.props.onCenterChanged(center)
                                }

                            });

                        }}
                        onClick={evt => {

                            if(mode === Method.Manual && args.type === SelectMode.UserDefined && !this.props.completePathDefinition){

                                const newPath = this.props.userPath.concat([ { lat: evt.latLng.lat() , lng: evt.latLng.lng() } ]);
                                if(this.props.onPathUpdated){
                                    this.props.onPathUpdated(newPath);
                                }

                            }


                        }}
                        defaultZoom={props.defaultZoom}
                        zoom={props.zoom}
                        onZoomChanged={props.onZoomChanged}
                        defaultCenter={props.defaultCenter}
                        options={mapOptions}>
            {renderHistoryPath()}
            {renderDrawing()}
            {renderComputationPaths()}
        </LoadMap>


    }

}




// WEBPACK FOOTER //
// ./src/components/AreaCalculatorDialog/MapView.js